export const isUserViewerOrGuest = userRoles => userRoles.some(r => ['viewer', 'guest'].includes(r))
